import { Container } from 'components/baseStyles/CommonStyle.styled';
import { styled } from 'styled-components';

export const Header = styled.header`
  /* color: ${props => props.theme.black};
  background-color: ${props => props.theme.white}; */

  /* @media screen and (max-width: 1279.9px) { */
  /* display: flex;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 45px;
    opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
    transition: opacity 0.3s, transform 0.3s;
    z-index: 999; */
  /* } */
  background-color: #faf5ef;

  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 215;

  width: 100vw;
  padding: 20px;
  border-bottom: 1px solid #a4907c;
`;

export const HeaderContainer = styled(Container)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-content: center;
  text-align: left;

  padding: 0;

  @media screen and (min-width: 768px) {
    padding: 0 30px;
  }

  @media screen and (min-width: 1440px) {
    max-width: 1440px;
    padding: 0 80px;
  }
`;

export const HeaderNav = styled.nav`
  & > ul {
    display: none;

    @media screen and (min-width: 1280px) {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 40px;
    }

    & > li > a {
      color: #000000;
      font-size: 20px;
      font-family: 'Playfair Display', sans-serif;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-decoration: none;
      position: relative;
      display: inline-block;
      transition: all 150ms linear;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 0;
        height: 2px;
        background-color: #000;
        transition: width 0.3s ease;
      }

      &:hover::after,
      &:focus::after {
        width: 100%;
      }
    }
  }
`;

export const NavButton = styled.button`
  color: #000000;
  font-size: 20px;
  font-family: 'Playfair Display', sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  background-color: transparent;
  border: none;
  text-decoration: none;
  position: relative;
  display: inline-block;
  transition: all 150ms linear;
  cursor: pointer;
  padding: 0;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 2px;
    background-color: #000;
    transition: width 0.3s ease;
  }

  &:hover::after,
  &:focus::after {
    width: 100%;
  }
`;

export const HeaderList = styled.ul`
  display: flex;
`;

export const LogoImg = styled.img`
  width: 120px;
  @media screen and (min-width: 1280px) {
    width: 190px;
  }
`;

export const LogoBox = styled.a`
  text-decoration: none;
  cursor: pointer;
`;

export const HeaderSvg = styled.svg`
  fill: currentColor;
  cursor: pointer;
  position: absolute;
  top: 42px;
  right: 20px;

  @media screen and (min-width: 1280px) {
    display: none;
  }
`;
